<span
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss">
  @if (isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }
  <div
    #jsonBody
    [ngClass]="[
      'input-json-body',
      (!chips || !chips.length) && isMandatory ? 'mandatory' : '',
      isReadOnly ? 'disabled' : '',
      isReadOnly && !chips?.length ? 'input-json-empty' : '',
    ]">
    <div class="json-chip-list" role="list" [attr.aria-label]="label">
      @for (chip of chips; track i; let i = $index) {
        <div
          class="json-chip"
          role="listitem"
          [attr.title]="getChipTitle(chip)"
          [ngClass]="{ 'json-chip-selected': selectedChipIndex === i, 'json-chip-duplicate': duplicateChipIndex === i }">
          @if (isTagField) {
            <i class="json-chip-prefix icon-hashtag" aria-hidden="true"></i>
          }
          <span class="json-chip-label" (click)="showCreationPanel($event, chip)">
            @if (fieldDisplayeds?.length === 1) {
              <p>{{ chip[fieldDisplayeds[0].name] }}</p>
            } @else {
              @for (fieldDisplayed of fieldDisplayeds; track $index) {
                <p class="multiLabel">{{ fieldDisplayed.nameToShow }} = {{ chip[fieldDisplayed.name] }}</p>
              }
            }
          </span>
          @if (!isReadOnly) {
            <button
              class="remove-json-chip"
              type="button"
              [attr.aria-label]="
                (isTagField ? 'tagsEditor.removeTag' : 'inputJson.removeChip') | translate: { tag: getChipTitle(chip) }
              "
              (click)="removeJsonChip($event, i)">
              <i class="icon-cross" aria-hidden="true"></i>
            </button>
          }
        </div>
      }
      @if (!isReadOnly && !chips?.length && !uniqueProp && isTagField) {
        <span class="json-chip-empty json-chip-placeholder" (click)="showCreationPanel($event)">
          {{ 'inputJson.noTag' | translate }}
        </span>
      }
      <div
        class="json-input"
        [ngStyle]="!this.uniqueProp || (!hasMultiValues && chips.length === 1) ? { display: 'none' } : {}">
        <input
          #inputtext
          autocomplete="off"
          data-cy="input-json"
          type="text"
          [attr.data-cy-columnName]="columnName"
          [attr.placeholder]="chips && chips.length ? null : isTagField ? ('tagsEditor.placeholder' | translate) : placeholder"
          [disabled]="isReadOnly"
          [ngClass]="[
            'chip-input',
            chips?.length > 0 && inputtext.value.trim() === '' ? 'chip-input-small' : '',
            isNotAuthorized ? 'redText' : '',
          ]"
          [ngStyle]="this.focused && inputtext.value.trim() !== '' ? { width: '100%' } : {}"
          [ngStyle]="inputStyle"
          [readonly]="isReadOnly"
          [tabindex]="isReadOnly ? '-1' : null"
          (blur)="selectedChipIndex = -1; onInputBlur($event)"
          (focus)="!isReadOnly ? onInputFocus($event) : null"
          (keydown)="onKeydown($event)" />
      </div>
    </div>
    @if (!this.uniqueProp && !isReadOnly && (hasMultiValues || chips.length === 0)) {
      <button
        class="add-json-chip"
        data-cy="input-json-add"
        type="button"
        [attr.aria-label]="panelTitleKeyNew | translate"
        [title]="panelTitleKeyNew | translate"
        (click)="showCreationPanel($event)">
        <i class="icon-add" aria-hidden="true"></i>
      </button>
    }
  </div>
  @if (hasConflict && dataStored) {
    <i
      #spanInput
      role="button"
      tabindex="0"
      [attr.title]="opConflict.iconTooltip"
      [attr.aria-label]="opConflict.iconTooltip"
      class="rtconflict fas fa-exclamation-triangle iconClass"
      (click)="showConflictPanel($event)"
      (keydown.enter)="showConflictPanel($event)"
      (keydown.space)="showConflictPanel($event)"></i>
  }

  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-prime-overlay #opCreation appendTo="body" styleClass="iu-input-json-panel" [handleAlign]="alignCreationPanel">
  <div
    class="vcrJsonCreationContainer"
    role="dialog"
    [attr.aria-label]="panelTitleKey | translate"
    (keydown)="onPanelKeydown($event)">
    <div class="json-panel-title">{{ panelTitleKey | translate }}</div>
    <div #jsonFieldsContainer class="jsonFields">
      <ng-template #vcrCreation />
    </div>

    <div class="json-panel-footer">
      <!-- free JSON: one more key/value line ("Ajout simple"), ">" reveals the object line -->
      @if (isFree) {
        <div class="inputjson-split-button json-panel-more">
          <div class="inputjson-split-button-toggle-button" [ngClass]="{ 'split-button-open': isSplitButtonOpen }">
            <button class="json-panel-link add-panel-line" type="button" (click)="addLineToPanel($event)">
              <i class="icon-add" aria-hidden="true"></i>
              {{ 'inputJson.addString' | translate }}
            </button>
            <button
              class="json-panel-link add-panel-line"
              type="button"
              [attr.aria-expanded]="isSplitButtonOpen"
              [attr.aria-label]="'inputJson.addObject' | translate"
              [title]="'inputJson.addObject' | translate"
              (click)="$event.stopPropagation(); isSplitButtonOpen = !isSplitButtonOpen">
              <i aria-hidden="true" [ngClass]="isSplitButtonOpen ? 'icon-open' : 'icon-next'"></i>
            </button>
          </div>
          @if (isSplitButtonOpen) {
            <div class="inputjson-split-button-list">
              <button class="json-panel-link" type="button" (click)="addLineToPanel($event, true)">
                <i class="icon-add" aria-hidden="true"></i>
                {{ 'inputJson.addObject' | translate }}
              </button>
            </div>
          }
        </div>
      }
      <div class="json-panel-actions">
        <button
          class="p-button-secondary"
          data-cy="input-json-panel-cancel"
          pButton
          type="button"
          [label]="'generic.cancel' | translate"
          (click)="closePanel($event)"></button>
        <button
          class="p-button-primary"
          data-cy="input-json-panel-validate"
          pButton
          type="button"
          [disabled]="!canCommitPanel()"
          [label]="(isEditingChip ? 'generic.save' : 'generic.add') | translate"
          (click)="commitPanel($event)"></button>
      </div>
    </div>
  </div>
</iu-prime-overlay>

<iu-field-conflict-panel #opConflict [field]="this" />
